import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import { setupListeners } from "@reduxjs/toolkit/query";
import storage from "redux-persist/lib/storage";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import { apiSlice } from "./services/apiSlice";
import authReducer from "./features/auth/authSlice";
import tenantReducer from "./features/tenant/tenantSlice";
import roleReducer from "./features/role/roleSlice";
import processReducer from "./features/process/processSlice";
import appReducer from "./features/app/appSlice";
import filterReducer from "./features/filter/filterSlice";


const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ["api"],
};

export const rootReducers = combineReducers({
  // Add the generated reducer as a specific top-level slice
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
    tenant: tenantReducer,
    role: roleReducer,
    process: processReducer,
    app: appReducer,
    filter: filterReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducers);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat([
      apiSlice.middleware,
    ]),
  devTools: true,
});

setupListeners(store.dispatch);
